import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay"];

  show() {
    this.overlayTarget.showModal();
  }

  hide() {
    this.overlayTarget.close();
  }
}
